/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import {
  renderDefaultError,
  renderDefaultLoading,
} from '@exo/frontend-common-utils';
import { useNavigate } from 'react-router-dom';
import { usePriceRange } from '../../hooks/usePriceRange';
import { waitForRequestsToComplete } from '../../../../../../../packages/common/apollo/client/links/activeRequests';
import { generateUrlWithLanguage } from '../../../../../../utils';
import { useSessionContext } from '@exo/frontend-common-session-context';

export const ProductPriceContainer = ({
  partNumber,
  quantity,
  render,
  renderLoading = renderDefaultLoading,
  renderError = renderDefaultError
}: any) => {
  const navigate = useNavigate();
  let priceObj
  const {
    loading,
    error,
    data
  } = usePriceRange([partNumber], 'CAD', { fetchPolicy: 'network-only' });
  const session = useSessionContext()
  if (loading || !data) return renderLoading();
  if (error){
    navigate(generateUrlWithLanguage('/error',session.language))
    return;
  };
  if(data.price){
const allPriceRange = data?.price?.entitledPrice?.filter(eachProd => eachProd?.partNumber === partNumber)[0]
        ?.rangePrice;
  const getPriceObj = (priceRangeData, quantity) => {
    const result = priceRangeData && priceRangeData?.filter(
      eachData =>
        quantity >= eachData?.minimumQuantity?.value && quantity <= eachData?.maximumQuantity?.value
    );
    if (result?.length) {
      return result[0]?.priceInRange;
    } else {
      return priceRangeData && priceRangeData[priceRangeData?.length - 1]?.priceInRange;
    }
  };
   priceObj = getPriceObj(allPriceRange, quantity);
  }
  else{
    priceObj = null
  }
  
  if(data){return render({ priceObj });}
  if(loading) return renderLoading();
  
};

